import { Box, Typography, makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { getAvailableBalance } from '../Selectors'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000000',
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  textContainer: {
    width: '100%',
  },
  cfdLarge: theme.custom.large1, // a3700
  h2: theme.typography.h2, // a3700
  h3: theme.typography.h3,
}))

export const VNBalanceLookup = (props) => {
  const styles = useStyles()

  const availableBalance = useSelector((state) => getAvailableBalance(state))

  return (
    <Box className={styles.root}>
      <Box className={styles.center} pb={5}>
        <Box className={styles.textContainer}>
          <Box pb={1}>
            <Typography className={styles.h2}>Available Balance</Typography>
          </Box>
          <Typography className={styles.cfdLarge}>{availableBalance}</Typography>
        </Box>
      </Box>
    </Box>
  )
}
